// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5c542131","description":"_6bf0da64","imageWrapper":"_3cd23256","image":"_7a745085","title":"_1d3b4bc2","creator":"_c2f6e8be"};